
const translations = {
    PASS_MODAL_APPROVING_MANAGER: {
        description: 'Approving Manager',
        primaryValue: 'Approving Manager',
        stringKey: 'PASS_MODAL_APPROVING_MANAGER',
    },
    PASS_MODAL_DATE_RANGE_HEADING:{
        description: 'Date Range',
        primaryValue: 'Date Range',
        stringKey: 'PASS_MODAL_DATE_RANGE_HEADING'
    },
    PASS_MODAL_DATE_RANGE_SINGLE:{
        description: 'Single Date',
        primaryValue: 'Most pass types are valid for {{number}} day',
        stringKey: 'PASS_MODAL_DATE_RANGE_SINGLE'
    },
    PASS_MODAL_DATE_RANGE_MULTIPLE:{
        description: 'Multiple Dates',
        primaryValue: 'Most pass types are valid for {{number}} days',
        stringKey: 'PASS_MODAL_DATE_RANGE_MULTIPLE'
    },
    PASS_DATE_ALERT_START_DATE_AFTER:{
        description: 'Selected start date is after end date of selected pass',
        primaryValue: 'Selected start date is after end date of selected pass',
        stringKey: 'PASS_DATE_ALERT_START_DATE_AFTER'
    },
    PASS_DATE_ALERT_START_DATE_BEFORE:{
        description: 'Selected start date is before the start date of selected pass',
        primaryValue: 'Selected start date is before the start date of selected pass',
        stringKey: 'PASS_DATE_ALERT_START_DATE_BEFORE'
    },
    PASS_MODAL_DATE_RANGE_ALTERNATE_PLURAL:{
        description: 'Pass only active for {{number}} days because of date pass type selected',
        primaryValue: 'Pass only active for {{number}} days because of date pass type selected',
        stringKey: 'PASS_MODAL_DATE_RANGE_ALTERNATE_PLURAL'
    },
    PASS_MODAL_DATE_RANGE_ALTERNATE_SINGLE:{
        description: 'Pass only active for {{number}} day because of date pass type selected',
        primaryValue: 'Pass only active for {{number}} day because of date pass type selected',
        stringKey: 'PASS_MODAL_DATE_RANGE_ALTERNATE_SINGLE'
    }
}

export default translations;